import { Form } from "antd"
import { useLocation, useNavigate } from "react-router-dom"
import { useResetPassword } from "./ResetPasswordQuery";
import { NavigationRoutes } from "@Navigation/NavigationRoutes";
import { ResetPasswordPayload } from "@Pages/AuthScreens/Login/types";

export default function useResetPasswordContainer() {

	const [form] = Form.useForm()
	const navigate = useNavigate();
	const location = useLocation();
	const state = (location.state || {}) as { token?: string; email?: string | null };
	const token = state?.token && state.token.length > 0
		? state.token
		: (sessionStorage.getItem("resetPasswordToken") || "");
	const email = (state?.email ?? null) ?? (sessionStorage.getItem("resetPasswordEmail") || null);

	const onResetPassSuccess = (_payload: ResetPasswordPayload) => {
		try {
			sessionStorage.removeItem("resetPasswordToken");
			sessionStorage.removeItem("resetPasswordEmail");
		} catch {}
		navigate(NavigationRoutes.AUTH_ROUTES.LOGIN)
	};

	const { mutate: resetPassword, isPending: isResettingPassword } = useResetPassword(onResetPassSuccess);

	const handleSubmit = (data: any) => {
		const payload: ResetPasswordPayload = {
			email,
			token,
			password: data?.password ?? null,
			requestType: "Password"
		};
		resetPassword(payload);
	}

	const handleLogin = () => {
		navigate(NavigationRoutes.AUTH_ROUTES.LOGIN)
	}

	return {
		form,
		handleSubmit,
		handleLogin,
		isResettingPassword
	}
}